<template>
    <section class="card-download" id="card-download">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="title-wrap">
                        <h1>收集卡下載</h1>
                    </div>
                </div>
                <div class="col-12">
                    <div class="img-wrap">
                        <img :src="card" alt="">
                    </div>
                </div>
                <div class="col-12">
                    <div class="download-wrap">
                        <!-- <a target="_blank" class="bd-btn" href="./src/assets/pxmart-printingList1123_sc9v2.pdf">下載印花清單</a> -->
                        <button class="bd-btn download-card" @click="printImg(card)">下載活動收集卡</button>
                    </div>     
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import card from '../assets/card.png';


export default {
    data(){
        return {
            card,
        }
    },
    methods: {
        printImg(url){
            var pwin = window.open(url, "_blank");
            pwin.onload=function(){
                pwin.focus();
            }
            pwin.print();
        },
        ga_func(class_name, name){
            $("body").on('click', class_name , function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        }
    },
    mounted(){
        this.ga_func(".download-card", "首頁-下載活動收集卡");

        console.log("cdDown!!")
    }

}


</script>


<style lang="sass">
.card-download
    .row
        background-image: url('../assets/grey-bg.jpg')
        background-size: 100%
        background-position: center 0
        border-radius: 0 0 20px 20px
        @media (max-width: 576px)
            background-image: none
    .title-wrap
        margin-bottom: 70px
        background: black
        color: white
        margin-left: -15px
        margin-right: -15px
        font-weight: 300
        padding: 20px 0
        @media (max-width: 576px)
            margin-bottom: 50px
            background: none
            border-bottom: 1px solid white
            margin-left: 0px
            margin-right: 0px
            padding-top: 50px
        h1
            text-align: center
            font-weight: 300
            margin-bottom: 3px
            letter-spacing: 2px
            font-size: 32px
        p
            text-align: center
            margin-bottom: 0
            font-size: 14px
            letter-spacing: 2px
    .img-wrap
        padding: 0 20px
        margin-bottom: 70px
        @media (max-width: 576px)
            padding: 0
            margin-bottom: 0px
        img
            width: 100%
    .download-wrap
        margin-bottom: 90px
        @media (max-width: 768px)
            margin-bottom: 60px
        @media (max-width: 576px)
            margin-top: 40px

</style>



// WEBPACK FOOTER //
// src/Index/CardDownload.vue